import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-quotation-header',
  templateUrl: './quotation-header.component.html',
  styleUrls: ['./quotation-header.component.scss'],
  animations: [
    trigger('fadeInLeft', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ]),
    trigger('fadeInRight', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ]),
    trigger('fadeInDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class QuotationHeaderComponent implements OnInit {
  @ViewChild('menu') menu!: Menu;
  userMenuOpen = false;
  isCollapsed = true;
  items: MenuItem[] = [];
  @Output() collapsedState = new EventEmitter<boolean>();
  
  // Add properties for user data
  currentUser: any = null;
  username: string = 'Guest User';
  userRole: string = 'No Role';

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.collapsedState.emit(this.isCollapsed);
    
    // Get current user data
    this.loadUserData();
    
    this.items = [
      {
        label: 'My Profile',
        icon: 'pi pi-user',
        command: () => this.router.navigate(['/profile'])
      },
      {
        label: 'Settings',
        icon: 'pi pi-cog',
        command: () => this.router.navigate(['/settings'])
      },
      {
        separator: true
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => {
          this.logout();
        }
      }
    ];
  }

  private loadUserData(): void {
    this.currentUser = this.authService.getCurrentUser();
    
    if (this.currentUser) {
      // Extract username - adjust field names based on your database structure
      this.username = this.currentUser.name || this.currentUser.username || this.currentUser.employeeNumber || 'User';
      
      // Extract user role - adjust based on your database structure
      this.userRole = this.getUserRoleDisplay(this.currentUser.role);
    }
  }

  private getUserRoleDisplay(role: any): string {
    if (!role) return 'No Role';
    
    // Handle different role structures
    if (typeof role === 'string') {
      return this.formatRoleString(role);
    } else if (typeof role === 'object') {
      // If role is an object with name, displayName, or code properties
      return this.formatRoleString(
        role.displayName || role.name || role.code || 'Unknown Role'
      );
    }
    
    return 'No Role';
  }

  private formatRoleString(roleString: string): string {
    // Convert role codes to display names
    const roleDisplayMap: { [key: string]: string } = {
      'admin': 'Administrator',
      'super_admin': 'Super Admin',
      'user': 'User',
      'manager': 'Manager',
      'employee': 'Employee',
      'quotation_manager': 'Quotation Manager'
    };

    return roleDisplayMap[roleString.toLowerCase()] || 
           roleString.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }

  private logout(): void {
    this.authService.logout();
    this.router.navigate(['/quotation-part/auth/login']);
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedState.emit(this.isCollapsed);
    console.log('Emitting collapsed state:', this.isCollapsed);
  }

  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
  }

  testMenu() {
    console.log('Button clicked!');
    this.menu.toggle(event);
  }

  toggleMenu(event: Event) {
    event.stopPropagation();
    this.menu.toggle(event);
    console.log('Menu toggled', this.menu);
  }

  showMenu(event: Event) {
    event.stopPropagation();
    this.menu.show(event);
    console.log('Menu should be visible now');
  }

  menuAction(option: number) {
    console.log(`Menu option ${option} clicked`);
  }
}